import React from 'react';
import pages from '../screens/all-pages';
import { Icon } from './icon.js';

export const ROUTE_LOGIN = 'https://central.zetta-system.com';
export const ROUTE_LOGIN_MANUAL = '/account/login';
export const ROUTE_HANDLE = '/account/handle';

export const KEY_ROUTE_MAIN = '@ROUTES/ROUTE_MAIN';
export const KEY_ROUTE_HOME = '@ROUTES/ROUTE_HOME';
export const KEY_ROUTE_REGISTER = '@ROUTES/ROUTE_REGISTER';
export const KEY_ROUTE_HOME_SCENE = '@ROUTES/ROUTE_HOME_SCENE';
export const KEY_ROUTE_LOGIN_DEALER = '@ROUTES/ROUTE_LOGIN_DEALER';
export const KEY_ROUTE_CLAIM_REGISTER = '@ROUTES/ROUTE_CLAIM_REGISTER';
export const KEY_ROUTE_PROFILE = '@ROUTES/ROUTE_PROFILE';
export const KEY_ROUTE_PROFILE_STORE = '@ROUTES/ROUTE_PROFILE_STORE';

function renderStyle(comp) {
  return <div style={{ marginRight: '1px' }}>{comp}</div>;
}

export const ROUTES_PATH = {
  ROUTE_MAIN: {
    KEY: KEY_ROUTE_MAIN,
    PATH: '/',
    LABEL: 'หน้าหลัก',
    COMPONENT: pages.HomeScene,
  },
  ROUTE_HOME: {
    KEY: KEY_ROUTE_HOME,
    PATH: '/home',
    LABEL: 'หน้าหลัก',
    COMPONENT: pages.HomeScene,
  },
  ROUTE_REGISTER: {
    KEY: KEY_ROUTE_REGISTER,
    ICON: renderStyle(<Icon.dashboard />),
    PATH: '/warranty',
    LABEL: 'หน้าหลัก',
    COMPONENT: pages.Register,
  },
  ROUTE_LOGIN_DEALER: {
    KEY: KEY_ROUTE_LOGIN_DEALER,
    PATH: '/login-dealer',
    LABEL: 'เข้าสู่ระบบร้านค้า',
    COMPONENT: pages.LoginDealer,
  },
  ROUTE_CLAIM_REGISTER: {
    KEY: KEY_ROUTE_CLAIM_REGISTER,
    PATH: '/claim/register',
    LABEL: 'ลงทะเบียนเคลม',
    COMPONENT: pages.ClaimScene,
  },
  ROUTE_PROFILE: {
    KEY: KEY_ROUTE_PROFILE,
    PATH: '/profile',
    LABEL: 'ข้อมูลส่วนตัว',
    COMPONENT: pages.ProfileScene,
  },
  ROUTE_PROFILE_STORE: {
    KEY: KEY_ROUTE_PROFILE_STORE,
    PATH: '/profile-store',
    LABEL: 'ข้อมูลร้านค้า',
    COMPONENT: pages.ProfileStore,
  },
};

function getKeyLowerCase(obj) {
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k.toLowerCase(), v]));
}

export const ROUTES_MENU = [getKeyLowerCase(ROUTES_PATH.ROUTE_REGISTER)];
